import type { SvgIconComponent } from "@mui/icons-material";
import { useId } from "react";

type Props = {
  Icon: SvgIconComponent;
};

export default function LidarAxisIcon({ Icon }: Props) {
  const gradientId = `lidar-axis-${useId().replace(/[^\w-]/g, "")}`;

  return (
    <>
      <svg width={0} height={0} style={{ position: "absolute" }} aria-hidden>
        <defs>
          <linearGradient
            id={gradientId}
            gradientUnits="userSpaceOnUse"
            x1="5"
            y1="19"
            x2="19"
            y2="5"
          >
            <stop offset="0.2" stopColor="#E53935" />
            <stop offset="0.5" stopColor="#43A047" />
            <stop offset="0.8" stopColor="#1E88E5" />
          </linearGradient>
        </defs>
      </svg>
      <Icon sx={{ fontSize: 64, fill: `url(#${gradientId})` }} />
    </>
  );
}
